function handleize(str) {
  return str.toLowerCase()
    .normalize('NFD') // Normalize the string to decompose accented characters
    .replace(/[\u0300-\u036f]/g, '') // Remove the decomposed accent characters
    .replace(/[^\w\s-]/g, '') // Remove any non-word characters except spaces and hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens
}

function escapeHtml(unsafe) {
  return unsafe.replace(/[&<"']/g, function(match) {
    switch (match) {
      case '&': return '&amp;';
      case '<': return '&lt;';
      case '>': return '&gt;';
      case '"': return '&quot;';
      case "'": return '&#039;';
      }
  });
}
function slateToHtml(node) {
  switch (node.type) {
    case "root":
 
      return node.children.map(slateToHtml).join("");

    case "paragraph":

      return `<p>${node.children.map(slateToHtml).join("")}</p>`;

    case "text":

      let text = node.value

      text = text.replace(/\n/g, "<br/>");
  
      if (node.bold) {
        text = `<strong>${text}</strong>`;
      }
      return text;


    default:
     
      return (node.children || []).map(slateToHtml).join("");
  }
}


let store_blocks_container = document.createElement('div');
store_blocks_container.innerHTML = window.selectorStoreBlocks;

let store_maps_container = document.createElement('div');
store_maps_container.innerHTML = window.selectorStoreMaps;

let store_selectors, single_store;
//let map_blocks_found = 0

let store_blocks_array = []
let map_blocks_array = []


const provinces = {
  'Quebec': 'QC',
  'Ontario': 'ON',
  'British Columbia': 'BC',
  'Alberta': 'AB',
  'Manitoba': 'MB',
  'Saskatchewan': 'SK',
  'Nova Scotia': 'NS',
  'New Brunswick': 'NB',
  'Prince Edward Island': 'PE',
  'Newfoundland and Labrador': 'NL',
}

  const mutation_local_pickup_location = `#graphql
    mutation cartBuyerIdentityUpdate($buyerIdentity: CartBuyerIdentityInput!, $cartId: ID!) {
      cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId) {
        userErrors {
          field
          message
        }
      }
    }
  `;

  const token = window.KROWN.settings.storefront_api_key;
  const domain = window.KROWN.settings.store_domain;
  const query = `#graphql
  query {
    locations(first: 250, sortKey: NAME) {
      nodes{
        address {
          address1
          city
          province
          zip
        }
        id
        metafields (identifiers: [
          { namespace: "additional_info",key: "lat"},
          { namespace: "additional_info",key: "lien_vers_franchise"},
          { namespace: "additional_info",key: "lng"},
          { namespace: "additional_info",key: "pickup_time"},
          { namespace: "additional_info",key: "store_details"},
        ]) {
          key
          namespace
          value
        }
        name
      }
    }
  }
`
fetch(`https://${domain}/api/2025-07/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': token,
    },
    body: JSON.stringify({ query }),
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    console.log(data);
    
    store_selectors = data.data.locations.nodes.filter(store => store.name !== 'Shop Santé Inc.').map(store => {
    let store_details = (store.metafields || []).reduce((acc, field) => {
      if (!field || !field.key) return acc;

      acc[field.key] = field.value;
      return acc;
    }, {});
      const parsedStoreDetails = JSON.parse(store_details.store_details);
      return {
        address: `${store.address.address1}, ${provinces[store.address.province]} ${store.address.zip}`,
        id: store.id.replace('gid://shopify/Location/', ''),
        lien_vers_franchise: store_details.lien_vers_franchise,
        name: store.name,
        pickup_time: store_details.pickup_time,
        lat: store_details.lat.toString(),
        lng: store_details.lng.toString(),
        store_details: slateToHtml(parsedStoreDetails),
      };
    });

    single_store = store_selectors.length === 1;

    let store_selector_item = store_blocks_container.querySelector('.store-selector-item')

    if(single_store && store_selector_item) {
      store_selector_item.classList.add('store-selector-item--active')
    }

    store_selectors.forEach((store, index) => {
      let store_block = store_blocks_container.cloneNode(true);

      let store_selector_container = store_block.querySelector('.store-selector-item')
      
      if (!store_selector_container) {
        return; // Skip this iteration if the element is not found
      }
      
      let section_id = store_selector_container.id
      store_selector_container.id += index
      store_selector_container.setAttribute('data-handle', handleize(store.name))
      store_selector_container.setAttribute('data-location-id', store.id)
      store_selector_container.setAttribute('data-title', escapeHtml(store.name))

      let header = store_selector_container.querySelector('.store-selector-item__header')
      header.setAttribute('aria-selected', single_store ? 'true' : 'false')
      header.setAttribute('aria-controls', `store-selector-tab-${handleize(store.name)}`)

      let input_container = header.querySelector('.store-selector-item__input-container input')
      input_container.id += handleize(store.name)
      // if (single_store) { input_container.style.display = 'none' }


      let item_header_container = header.querySelector('.store-selecotr-item__header-container')

      let item_header_container_title = header.querySelector('.store-selector-item__title strong')
      item_header_container_title.innerHTML = escapeHtml(store.name)

      if (store.address) {
        let address = document.createElement('span');
        address.classList.add('store-selector-item__store-adress')
        address.textContent = escapeHtml(store.address)

        let item_header_title = header.querySelector('.store-selector-item__title')
        item_header_title.insertAdjacentElement('afterend', address)
      }

      let item_header_container_subtitle = header.querySelector('.store-selector-item__subtitle')
      if(store.pickup_time) {
        item_header_container_subtitle.innerHTML += ` ${escapeHtml(store.pickup_time)}`
      }


      let item_header_button = header.querySelector('.store-selector-buttons button')
      item_header_button.setAttribute('data-title-store', escapeHtml(store.name))

      // let store_details = store.store_details.match(/<p>(.*?)<\/p>/);
      // if(store_details){
      //   const textNode = document.createTextNode(store_details[1]);
      //   item_header_button.after(textNode);
      //   // item_header_button.insertAdjacentElement('afterend', store_details[1])
      // }

      let body = store_selector_container.querySelector('.store-selector-item__body')

      if(store.store_details) {
        body.id += `${handleize(store.name)}-${section_id}${index}`

        let content = body.querySelector('.store-selector-item__address.rte')
        
        // Check current page language and translate store details if needed
        const currentLang = document.documentElement ? document.documentElement.getAttribute('lang') : null;
        let storeDetailsContent = store.store_details;
        
        if (currentLang === 'en') {
          // Translate French store details to English
          console.log('BEFORE translation:', storeDetailsContent);
          
          storeDetailsContent = storeDetailsContent
            .replace(/<strong>Heures d'ouverture<\/strong>/gi, '<strong>Opening Hours</strong>')
            .replace(/Heures d'ouverture/gi, 'Opening Hours')
            .replace(/Lun-Ven\s*:/gi, 'Mon-Fri:')
            .replace(/Sam-Dim\s*:/gi, 'Sat-Sun:')
            .replace(/lundi-vendredi\s*:/gi, 'Monday-Friday:')
            .replace(/samedi-dimanche\s*:/gi, 'Saturday-Sunday:')
            .replace(/(\d+)h(\d+)/gi, '$1:$2')
            .replace(/<strong>Voir les directives des ramassages<\/strong>/gi, '<strong>View pickup instructions</strong>')
            .replace(/Voir les directives des ramassages/gi, 'View pickup instructions')
            .replace(/directives/gi, 'instructions')
            .replace(/ramassages/gi, 'pickup');
            
  
        }
        
        content.innerHTML = storeDetailsContent

        let direction_button = body.querySelector('.direction_button')
        if(store.lat && store.lng) {
          let link = direction_button.querySelector('a')
          link.href = `http://www.google.com/maps/place/${escapeHtml(store.lat)},${escapeHtml(store.lng)}`
        } else {
          direction_button.remove()
        }

        let page_franchise = body.querySelector('.page_franchise')
        if(store.lien_vers_franchise) { ///pages/magasins/shop-sante-boisbriand
          let link = page_franchise.querySelector('a')
          if (link) {
            // Check current page language and modify URL accordingly
            const currentLang = document.documentElement ? document.documentElement.getAttribute('lang') : null;
            let franchiseUrl = store.lien_vers_franchise;
            
            if (currentLang === 'en' && franchiseUrl && !franchiseUrl.includes('/en/')) {
              // Add /en after the domain for English pages
              // Handle both absolute and relative URLs
              if (franchiseUrl.startsWith('/')) {
                // Relative URL: /pages/magasins/shop-sante-boisbriand
                franchiseUrl = '/en' + franchiseUrl;
              } else if (franchiseUrl.includes('://')) {
                // Absolute URL: https://example.com/pages/magasins/shop-sante-boisbriand
                franchiseUrl = franchiseUrl.replace(/^(https?:\/\/[^\/]+)(.*)$/, '$1/en$2');
              }
            }
            
            link.href = franchiseUrl;
          }
        } else {
          page_franchise.remove()
        }
      } else {
        body.remove()
      }
      store_blocks_array.push(store_selector_container)

      // MAP

      if(store.lat && store.lng) {
        //map_blocks_found++;
        let map = store_maps_container.querySelector('li')
        const clone = map.cloneNode(true)

        clone.setAttribute('data-id', handleize(store.name))
        clone.setAttribute('data-latitude', escapeHtml(store.lat))
        clone.setAttribute('data-longitude', escapeHtml(store.lng))

        map_blocks_array.push(clone)
      }
    })

    // --

    let modal_box = document.querySelector('modal-box#modal-store-selector')
    let map_address_block = modal_box.querySelector('ul.map-addresses')
    if (map_blocks_array.length == 0) {
      map_address_block.remove()
    } else {
      map_blocks_array.forEach(node => {
        const clone = node.cloneNode(true)
        map_address_block.appendChild(clone)

      })
    }

    let store_selector_block = modal_box.querySelector('store-selector#StoreSelector')
    if(store_blocks_array.length == 0) {
      store_selector_block.remove()
    } else {
      if (single_store) {
        store_selector_block.setAttribute('data-single-store', '')
      }
      let selector_list = store_selector_block.querySelector('div.store-selector-list')
      store_blocks_array.forEach(node => {
        const clone = node.cloneNode(true)
        selector_list.appendChild(clone)
      })
    }

    /* --------------- */
    if ( typeof StoreSelector !== 'function' ) {

      class StoreSelector extends HTMLElement {

        constructor() {

          super();

          this.mainSelector = this.hasAttribute('data-main-selector');
          this.storeSelectorButton = this.mainSelector ? document.querySelector('[data-js-select-store]') : null;
          this.canChangeStore = true;

          const interactiveMap = document.getElementById(this.dataset.mapSelector);

          if ( this.mainSelector && this.hasAttribute('data-single-store') ) {
            localStorage.setItem('selected-store', this.querySelector('.store-selector-item').getAttribute('data-handle'));
          }
          const selectedStore = localStorage.getItem('selected-store');
          let selectedStoreFound = false;
          this.storesList = [];
          this.querySelectorAll('.store-selector-item').forEach(elm=>{

            const item = elm;
            this.storesList[item.dataset.handle] = item.dataset.title;

            if ( selectedStore && selectedStore == item.getAttribute('data-handle') ) {

              this._setSelectedStore(item, item);
              // this.changeSelectedStoreHandleContent(selectedStore);
              selectedStoreFound = true;

              if ( interactiveMap ) {
                interactiveMap.addEventListener('ready', ()=>{
                  setTimeout(()=>{
                    new google.maps.event.trigger(interactiveMap.markers[item.dataset.handle], 'click');
                  }, 1000);
                })
              }

            }

            if ( ! this.hasAttribute('data-single-store') ) {

              const toggleEl = document.createElement('div');
              toggleEl.classList = `js-accordion-tab-toggle ${this.mainSelector ? 'js-accordion-tab-toggle--main' : ''}`;
              toggleEl.tabIndex = 0;
              toggleEl.innerHTML = `
                <span>${KROWN.settings.locales.store_selector_store_info}</span>
                ${KROWN.settings.symbols.toggle_pack_alternate_v2}
              `;
              const storeSelectorButtons = item.querySelectorAll('.store-selector-buttons');

              storeSelectorButtons.forEach(button => {
                button.appendChild(toggleEl.cloneNode(true)); // Clone toggleEl before appending to avoid moving the same element
              });

              if ( this.mainSelector ) {
                const changeStoreEv = e=>{
                  document.querySelector('[data-store-popup-title]').innerText = document.querySelector('[data-store-popup-title]').getAttribute('data-store-title-available');
                  document.querySelector('[data-store-text]').innerText = document.querySelector('[data-store-text]').getAttribute('data-store-text-available') + ' ' + item.getAttribute('data-title') + '.';
                  this._clearSelectedStore(item);
                  this._setSelectedStore(item, e.target);
                  if ( interactiveMap ) {
                    if ( item.classList.contains('store-selector-item--store--active') ) {
                      new google.maps.event.trigger(interactiveMap.markers[item.dataset.handle], 'click');
                    }
                  }
                }

                item.querySelector('[data-js-select-store]').addEventListener('click', changeStoreEv);
                item.querySelector('[data-js-select-store]').addEventListener('keyup', e=>{
                  if ( e.keyCode == window.KEYCODES.RETURN ) {
                    changeStoreEv(e);
                  }
                });
              }

              const openAccordionEv = () => {
                this._openStoreTab(item);
                this.canChangeStore = false;


                if ( interactiveMap ) {
                  if ( item.classList.contains('store-selector-item--active') ) {
                    new google.maps.event.trigger(interactiveMap.markers[item.dataset.handle], 'click');
                  }
                }

                if ( item.querySelector('css-slider') ) {
                  item.querySelector('css-slider').resetSlider();
                }
              }

              item.querySelector(`${this.mainSelector ? '.js-accordion-tab-toggle' : '.js-accordion-tab'}`).addEventListener('click', openAccordionEv);
              item.querySelector(`${this.mainSelector ? '.js-accordion-tab-toggle' : '.js-accordion-tab'}`).addEventListener('keyup', e=>{
                if ( e.keyCode == window.KEYCODES.RETURN ) {
                  openAccordionEv();
                }
              });

            }

          });

          if ( this.storeSelectorButton && selectedStoreFound == false ) {
            this.storeSelectorButton.classList.add('show-select-label');
          }

          if ( interactiveMap ) {
            interactiveMap.addEventListener('marker', (e)=>{
              if ( this.canChangeStore ) {
                const item = this.querySelector(`.store-selector-item[data-handle="${e.detail.store}"]`);
                if ( ! item.classList.contains('store-selector-item--store--active' ) ) {
                  this._clearSelectedStore(item);
                  this._setSelectedStore(item, item);
                }
              } else {
                this.canChangeStore = true;
              }
            });
          }

          // if ( document.querySelector('[data-js-select-store]') ) {
          //   const storeChanged = new CustomEvent('storechanged');
          //   document.querySelectorAll('[data-js-select-store] [data-js-change-store]').forEach(elem => {
          //     elem.addEventListener('click', e => {
          //       e.preventDefault();
          //       const currentWrapper = elem.closest('.store-selector-item')
          //       const parentElement = elem.closest('[data-js-select-store]');
          //       const mainParentElement = parentElement.closest('.store-selector-item');

          //       const changeLabel = elem.querySelector('.store-selector-set__change-label');
          //       const setLabel = elem.querySelector('.store-selector-set__set-label');

          //       console.log(currentWrapper.classList.contains('store-selector-item--store--active'), 'active')

          //       if (mainParentElement && !currentWrapper.classList.contains('store-selector-item--store--active')) {
          //         const selectedStoreNew = mainParentElement.getAttribute('data-handle');
          //         localStorage.setItem('selected-store', selectedStoreNew);
          //         this.changeSelectedStoreHandleContent(selectedStoreNew);
          //       } else {
          //         localStorage.removeItem('selected-store');
          //         this.changeSelectedStoreHandleContent();
          //       }

          //       // Toggle display of labels
          //       if (changeLabel && setLabel) {
          //         changeLabel.style.display = 'flex';
          //         setLabel.style.display = 'none';
          //       }

          //       document.querySelectorAll('[data-js-select-store] [data-js-change-store]').forEach(otherElem => {
          //         const otherSetLabel = otherElem.querySelector('.store-selector-set__set-label');
          //         const otherChangeLabel =  otherElem.querySelector('.store-selector-set__change-label');
          //         if (otherSetLabel && otherElem !== elem) {
          //           otherSetLabel.style.display = 'flex';
          //           otherChangeLabel.style.display = 'none';
          //         }
          //       });

          //       this.dispatchEvent(storeChanged);
          //     });
          //   });

          document.querySelectorAll('[data-js-reset-store]').forEach(resetButton => {
            resetButton.addEventListener('click', e => {
              if(resetButton.querySelector('#shipping-fee').checked === true){
                localStorage.removeItem('selected-store');
                this.changeSelectedStoreHandleContent();
              }
            });
          });
          // }
        }


        _show(){}
        _openStoreTab(item) {
          const open = item.classList.contains('store-selector-item--active') ? false : true;
          this.querySelectorAll('.store-selector-item--active').forEach(elm=>{
            this._slideUp(elm.querySelector('[role=tabpanel]'), 200);
            elm.classList.remove('store-selector-item--active');
          });
          if ( open ) {
            item.classList.add('store-selector-item--active');
            this._slideDown(item.querySelector('[role=tabpanel]'), 200);
          }
        }

        _clearSelectedStore(item) {
          if ( ! item.classList.contains('store-selector-item--store--active') && this.querySelector('.store-selector-item--store--active') ) {
            this.querySelector('.store-selector-item--store--active input').checked = false;
            this.querySelector('.store-selector-item--store--active').classList.remove('store-selector-item--store--active');
          }
        }

        _setSelectedStore(item, button) {
          const input = item.querySelector('input');
          const isActive = item.classList.toggle('store-selector-item--store--active');
          input.checked = isActive;
          button.setAttribute('aria-selected', String(isActive));
          const selectedStoreNew = item.getAttribute('data-handle');
          const itemId = item.getAttribute('data-location-id');

          if (this.storeSelectorButton) {
            if (isActive) {
              localStorage.setItem('selected-store', selectedStoreNew);
              this.changeSelectedStoreHandleContent(selectedStoreNew);
              this._setCartPickupLocation(itemId);
            } else {
              localStorage.removeItem('selected-store');
              this.changeSelectedStoreHandleContent();
            }

            // document.querySelectorAll('[data-js-select-store] [data-js-change-store]').forEach(otherElem => {
            //   if (otherElem !== item.querySelector('[data-js-change-store]')) {
            //     otherElem.querySelector('.store-selector-set__set-label').style.display = 'flex';
            //     otherElem.querySelector('.store-selector-set__change-label').style.display = 'none';
            //   }
            // });
          }
        }

        async _setCartPickupLocation(itemId) {
              if ( ! itemId ) {
                console.warn('No item ID provided for setting cart pickup location.');
                return;
              }
              const cart = await fetch(window.Shopify.routes.root + "cart.js", {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  "Accept-Control-Allow-Origin": "*",
                },
              });

              if (!cart.ok) {
                throw new Error('Failed to fetch cart ID');
              }

              const cartData = await cart.json();
              const rawCartId = cartData.token;

            
              const variables = {
                "cartId": `gid://shopify/Cart/${rawCartId}`,
                "buyerIdentity": {
                  "preferences": {
                    "delivery": {
                      "deliveryMethod": "PICK_UP",
                      "pickupHandle": itemId.toString(),
                    }
                  }
                },
              };
              const query = mutation_local_pickup_location;

               const response = await fetch(`https://${domain}/api/2025-07/graphql.json`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Shopify-Storefront-Access-Token': token,
                },
                body: JSON.stringify({ 
                  query: query, 
                  variables: variables
                }),
              })

              if (!response.ok) {
                throw new Error('Failed to set cart pickup location');
              }
              
        
        }

        changeSelectedStoreHandleContent(store = null) {
          if ( this.mainSelector ) {
            document.querySelectorAll('[data-type="store-selector"]').forEach(storeSelectorHandle=>{
              const shoppingFeeToggle = storeSelectorHandle.querySelector('#shipping-fee');
              shoppingFeeToggle.checked = true;
              if ( store ) {
                // get closing time
                let storeClosingHours = '';
                if ( document.querySelector('.store-selector-item--store--active .store-selector-item__closing-times') ) {
                  const today = new Date().getDay();
                  const closingTimes = document.querySelector('.store-selector-item--store--active .store-selector-item__closing-times').querySelectorAll('p');
                  if ( closingTimes[today] ) {
                    storeClosingHours = ` &nbsp;|&nbsp; ${closingTimes[today].textContent}`;
                  }
                }
                //select_store_label
                storeSelectorHandle.querySelector('[data-store-title]').innerHTML = `${KROWN.settings.locales.store_selector_title_selected}${storeClosingHours}`;
                storeSelectorHandle.querySelector('[data-store-label]').setAttribute('data-active-shop', 'true')
                storeSelectorHandle.querySelector('[data-store-label]').textContent = this.storesList[store];
                storeSelectorHandle.querySelector('[data-store-label]').setAttribute('data-store-label', this.storesList[store]);

                if ( this.storeSelectorButton ) {
                  this.storeSelectorButton.classList.add('show-change-label');
                  this.storeSelectorButton.classList.remove('show-select-label');
                }

              } else {
                document.querySelector('[data-store-popup-title]').innerText = document.querySelector('[data-store-popup-title]').getAttribute('data-store-title-unavailable');
                document.querySelector('[data-store-text]').innerText = document.querySelector('[data-store-text]').getAttribute('data-store-text-unavailable');
                storeSelectorHandle.querySelector('[data-store-label]').setAttribute('data-store-label', 'Shop Santé Inc.');
                storeSelectorHandle.querySelector('[data-store-title]').textContent = decodeURIComponent(KROWN.settings.locales.store_selector_title_default).replaceAll("&#39;", "'");
                storeSelectorHandle.querySelector('[data-store-label]').textContent = KROWN.settings.locales.store_selector_label.replaceAll("&#39;", "'");
                this._clearSelectedStore(storeSelectorHandle);
                setTimeout(()=>{
                  shoppingFeeToggle.checked = false;
                }, 100)
              }
            })
          }
          const storeChanged = new CustomEvent('storechanged', { detail: { store } });
          this.dispatchEvent(storeChanged);
        }

    		_slideUp(target, duration){
    			target.style.transitionProperty = 'height, margin, padding';
    			target.style.transitionDuration = duration + 'ms';
    			target.style.boxSizing = 'border-box';
    			target.style.height = target.offsetHeight + 'px';
    			target.offsetHeight;
    			target.style.overflow = 'hidden';
    			target.style.height = 0;
    			target.style.paddingTop = 0;
    			target.style.paddingBottom = 0;
    			target.style.marginTop = 0;
    			target.style.marginBottom = 0;
    			setTimeout(()=>{
    				target.style.display = 'none';
    				target.style.removeProperty('height');
    				target.style.removeProperty('padding-top');
    				target.style.removeProperty('padding-bottom');
    				target.style.removeProperty('margin-top');
    				target.style.removeProperty('margin-bottom');
    				target.style.removeProperty('overflow');
    				target.style.removeProperty('transition-duration');
    				target.style.removeProperty('transition-property');
    			}, duration);
    		}

    		_slideDown(target, duration) {
    			target.style.removeProperty('display');
    			var display = window.getComputedStyle(target).display;

    			if (display === 'none')
    				display = 'block';

    			target.style.display = display;
    			var height = target.offsetHeight;
    			target.style.overflow = 'hidden';
    			target.style.height = 0;
    			target.style.paddingTop = 0;
    			target.style.paddingBottom = 0;
    			target.style.marginTop = 0;
    			target.style.marginBottom = 0;
    			target.offsetHeight;
    			target.style.boxSizing = 'border-box';
    			target.style.transitionProperty = "height, margin, padding";
    			target.style.transitionDuration = duration + 'ms';
    			target.style.height = height + 'px';
    			target.style.removeProperty('padding-top');
    			target.style.removeProperty('padding-bottom');
    			target.style.removeProperty('margin-top');
    			target.style.removeProperty('margin-bottom');
    			setTimeout(()=>{
    				target.style.removeProperty('height');
    				target.style.removeProperty('overflow');
    				target.style.removeProperty('transition-duration');
    				target.style.removeProperty('transition-property');
    			}, duration);
    		}

      }

      if ( typeof customElements.get('store-selector') == 'undefined' ) {
        customElements.define('store-selector', StoreSelector);
      }

    }
  })
  .catch(error => { console.error('There has been a problem with your fetch operation:', error); });


function styleFirstWord(messages, color) {
  messages.forEach(message => {
    const text = message.textContent.trim();
    const words = text.split(' ');
    words[0] = `<span style="color: ${color};">${words[0]}</span>`;
    message.innerHTML = words.join(' ');
  });
}

const pickupMessagesAvailable = document.querySelectorAll('.pickup-message.available_for_pickup .text');
const pickupMessagesUnavailable = document.querySelectorAll('.pickup-message.unavailable_for_pickup .text');

styleFirstWord(pickupMessagesAvailable, '#58A77C');
styleFirstWord(pickupMessagesUnavailable, '#e56d6d');
